<section class="current__info {{ getBackgroundStyleName() }}">
    <div class="{{ getBackgroundWeatherStyleName() }}">
        <div class="current-top-info-box">
            <div class="time-txt">
                {{ currentInfo?.timeTag }}
            </div>
            <div class="info-txt">
                {{ "summary.flightStatusText" | translate }} 
                <span *ngIf="isPossibleFlight() == flightStatusCode.GOOD" class="accent">
                    {{ "summary.flightStatusGood" | translate }} 
                </span>
                <span *ngIf="isPossibleFlight() == flightStatusCode.DANGER" class="accent1">
                    {{ "summary.flightStatusBad" | translate }} 
                </span>
                <span *ngIf="isPossibleFlight() == flightStatusCode.CARE" class="accent2">
                    {{ "summary.flightStatusWarning" | translate }} 
                </span>
            </div>
        </div>
        <div class="current-mid-info-box">
            <div class="mid-box summary-group">
                <div class="tit-box type-mobile-center">
                    <i class="ic ic-place"></i>
                    <span class="txt">
                        {{ address }}
                    </span>
                </div>
                <div class="current-summary-box">
                    <div class="img-box">
                        <div class="weather-box {{ getWeatherStyleName() }}"></div>
                        <div *ngIf="isPossibleFlight() == flightStatusCode.GOOD" class="drone-box type-possible"></div>
                        <div *ngIf="isPossibleFlight() == flightStatusCode.DANGER" class="drone-box type-impossible"></div>
                        <div *ngIf="isPossibleFlight() == flightStatusCode.CARE" class="drone-box type-warning"></div>
                    </div>
                    <div class="txt-box">
                        <div class="top-box">
                            <div class="num-txt">
                                {{ userUnit.convertCalculatedWindSpeed(getCurrentInfo().data.windSpeed) }}
                            </div>
                            <div class="unit-txt">
                                {{ userUnit.convertWindSpeedUnitText() }}
                            </div>
                        </div>
                        <div *ngIf="currentInfo?.data" class="bottom-box">
                            <div class="wind-txt">
                                {{ currentWindDirection }}
                            </div>
                            <div class="wind-sub-txt">
                                {{ currentWindName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="current-data-box">
                    <ul>
                        <li>
                            <div class="ic-box">
                                <i class="ic ic-type1"></i>
                            </div>
                            <div class="subject-box">
                                {{ "weather.windGust" | translate }} 
                            </div>
                            <div class="data-box">
                                <span class="num-txt">
                                    {{ userUnit.convertCalculatedWindSpeed(getCurrentInfo().data.windGust) }}
                                </span>
                                <sup class="unit-txt">
                                    {{ userUnit.convertWindSpeedUnitText() }}
                                </sup>
                            </div>
                        </li>
                        <li>
                            <div class="ic-box">
                                <i class="ic ic-type2"></i>
                            </div>
                            <div class="subject-box">
                                {{ "weather.kpIndex" | translate }} 
                            </div>
                            <div class="data-box">
                                <span class="num-txt">
                                    <span *ngIf="currentKp == 0">
                                        -
                                    </span>
                                    <span *ngIf="currentKp != 0">
                                        {{ currentKp }}
                                    </span>
                                </span>
                                <sup class="unit-txt">
                                    N
                                </sup>
                            </div>
                        </li>
                        <li>
                            <div class="ic-box">
                                <i class="ic ic-type3"></i>
                            </div>
                            <div class="subject-box">
                                {{ "weather.temperature" | translate }} 
                            </div>
                            <div class="data-box">
                                <span class="num-txt">
                                    {{ userUnit.convertCalculatedTemperature(getCurrentInfo().data.temperature) }}
                                </span>
                                <sup class="unit-txt">
                                    {{ userUnit.convertTemperatureUnitText() }}
                                </sup>
                            </div>
                        </li>
                        <li>
                            <div class="ic-box">
                                <i class="ic ic-type4"></i>
                            </div>
                            <div class="subject-box">
                                {{ "weather.precipitationShort" | translate }} 
                            </div>
                            <div class="data-box">
                                <span class="num-txt">
                                    {{ currentInfo?.data?.precipitation }}
                                </span>
                                <sup class="unit-txt">
                                    %
                                </sup>
                            </div>
                        </li>
                        <li>
                            <div class="ic-box">
                                <i class="ic ic-type5"></i>
                            </div>
                            <div class="subject-box">
                                {{ "weather.humidity" | translate }} 
                            </div>
                            <div class="data-box">
                                <span class="num-txt">
                                    {{ currentInfo?.data?.humidity }}
                                </span>
                                <sup class="unit-txt">
                                    %
                                </sup>
                            </div>
                        </li>
                        <li *ngIf="selectedWeeklyIndex == 0">
                            <div class="ic-box">
                                <i class="ic ic-type6"></i>
                            </div>
                            <div class="subject-box">
                                {{ "weather.pm10" | translate }}
                            </div>
                            <div class="data-box">
                                <span class="num-txt">
                                    {{ dustInfo?.pm10 }}
                                </span>
                                <sup class="unit-txt">
                                    ㎍/㎥
                                </sup>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mid-box chart-group">
                <div class="tit-box">
                    <i class="ic ic-wind"></i>
                    <span class="txt">
                        {{ "weather.windSpeed" | translate }} 
                    </span>
                </div>
                <div class="current-chart-box">
                    <ul>
                        <li *ngFor="let weatherInfo of todayInfo?.infos">
                            <div class="item-box">
                                <div class="ic-box">
                                    <i class="ic ic-arrow" [ngStyle]="weatherInfo.getDirectionStyle()"></i>
                                </div>
                                <div class="bar-box type-blue" [ngStyle]="weatherInfo.getHeightPercentStyle(todayInfo.maxWindSpeed)">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedWindSpeed(weatherInfo.data.windSpeed) }}
                                    </span>
                                </div>
                            </div>
                            <div class="time-box">
                                {{ dateService.getTime(weatherInfo.timeTag) }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="current-bottom-info-box">
            <div class="list-wrap">
                <ul>
                    <li *ngFor="let dailyInfo of weeklyInfo; let i = index;" (click)="changeWeeklyInfo(i)" [class.type-current2]="i == selectedWeeklyIndex">
                        <div class="top-box">
                            <div class="day-txt">
                                {{ dateService.getDay(dailyInfo.date) }}
                            </div>
                            <div *ngIf="i == 0" class="date-txt">
                                {{ "summary.today" | translate }} 
                            </div>
                            <div *ngIf="i != 0" class="date-txt">
                                {{ dateService.getDate(dailyInfo.date) }}
                            </div>
                        </div>
                        <div class="mid-box">
                            <div class="weather-box {{ getDailyWeatherStyleName(i) }}"></div>
                            <div *ngIf="getDailyWeatherStatusCode(i) == flightStatusCode.GOOD"  class="state-box type-possible"></div>
                            <div *ngIf="getDailyWeatherStatusCode(i) == flightStatusCode.CARE"  class="state-box type-warning"></div>
                            <div *ngIf="getDailyWeatherStatusCode(i) == flightStatusCode.DANGER"  class="state-box type-impossible"></div>
                        </div>
                        <div class="bottom-box">
                            <div class="txt-box">
                                <span class="num-txt">
                                    {{ userUnit.convertCalculatedWindSpeed(dailyInfo.getAverageWindSpeed()) }}
                                </span>
                                <sup class="unit-txt">
                                    {{ userUnit.convertWindSpeedUnitText() }}
                                </sup>
                            </div>
                            <div class="txt-box">
                                <span *ngIf="kpInfoDto.length > i" class="num-txt">
                                    {{ kpInfoDto[i].getNextSunriseKp(dailyInfo.sunrise) }}
                                </span>
                                <span *ngIf="i >= kpInfoDto.length" class="num-txt">
                                    -
                                </span>
                                <sup class="unit-txt">
                                    N
                                </sup>
                            </div>
                            <div class="txt-box">
                                <span class="down-txt">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedTemperature(dailyInfo.getMinimumTemperature()) }}
                                    </span>
                                    <sup class="txt">
                                        °
                                    </sup>
                                </span>
                                <span class="slash-txt">
                                    /
                                </span>
                                <span class="up-txt">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedTemperature(dailyInfo.getMaximumTemperature()) }}
                                    </span>
                                    <sup class="txt">
                                        °
                                    </sup>
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>